import type {Location} from 'react-router'
import {useLocation} from 'react-router'
import {maybe} from '@freckle/maybe'
import {extractQueryParams} from '@freckle/educator-entities/ts/common/helpers/routers/query-params'
import {useSchools} from '@freckle/educator-entities/ts/common/hooks/use-schools'
import {WithResources} from '@freckle/school/ts/common/components/with-resources'
import {useSchoolAdmin} from '@freckle/school/ts/hooks/use-school-admin'
import type {TableParamsT} from '@freckle/school/ts/manage-teachers/components/api-controlled-table'
import type {TeacherTabFilteringT} from '@freckle/school/ts/manage-teachers/components/teacher-tab/'
import {RemoveSelfRosteredTeachersContainer} from './remove-self-rostered-teachers-container'

type QueryParamsProps = {
  tableParams: TableParamsT<TeacherTabFilteringT>
}

export default function RemoveSelfRosteredTeachersHandler() {
  const location = useLocation()
  const {tableParams} = getQueryParams(location)
  const schoolAdmin = useSchoolAdmin()
  const schools = useSchools()
  return (
    <WithResources
      resources={{schools, schoolAdmin}}
      render={({schools, schoolAdmin}) => {
        const schoolIds = schools.map(school => school.id)
        return (
          <RemoveSelfRosteredTeachersContainer
            schools={schools}
            currentSchoolIds={schoolIds}
            tableParams={tableParams}
            schoolAdmin={schoolAdmin}
          />
        )
      }}
    />
  )
}

function getQueryParams(location: Location): QueryParamsProps {
  const paramMap = extractQueryParams(location)

  const position = maybe(
    () => null,
    pMap => pMap.get('position'),
    paramMap,
  )
  const limit = maybe(
    () => null,
    pMap => {
      const val = pMap.get('limit')
      return val !== undefined ? parseInt(val, 10) : null
    },
    paramMap,
  )
  const searchValue = maybe(
    () => null,
    pMap => pMap.get('searchValue'),
    paramMap,
  )

  const tableParams = {
    position,
    limit: limit ?? 50,
    searchValue,
  }

  return {tableParams}
}
